import React, { useState } from 'react';
import { IconButton, Tooltip, CircularProgress } from '@mui/material';
import ShareRoundedIcon from '@mui/icons-material/ShareRounded';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import Whatsapp from '../../../images/Whatsapp';
import Telegram from '../../../images/Telegram';

import FileDownloader from '../../FileDownloader';

const ShareButton = ({
  apiUrl = '', 
  url = window.location.href, 
  title = document.title,
  description = '',
  docName = 'invoice',
  hashtags = []
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const [loading, setLoading] = useState(false);

  // Check if Web Share API is available (mobile devices)
  const canUseNativeShare = navigator.share !== undefined;

  let fileDownloader = new FileDownloader();

  const handleNativeShare = async () => {
    if (!apiUrl) return;
    try {
      setLoading(true);
      let blob = await fileDownloader.downloadFile(apiUrl);
      let file = fileDownloader.convertBlobToPdf(blob, docName);
      setLoading(false);
      if (file) {
        let files = [file];
        await navigator.share({
        title: title,
        text: description,
        url: url,
        files
      });
      }
    } catch (error) {
      // User cancelled or error occurred
      console.log('Share cancelled or failed:', error);
    } finally {
      setLoading(false);
    }
  };

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      console.error('Failed to copy:', error);
    }
  };

  const shareLinks = {
    whatsapp: `https://wa.me/?text=${encodeURIComponent(title + ' ' + url)}`,
    telegram: `https://t.me/share/url?url=${encodeURIComponent(url)}`,
    email: `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(description + '\n\n' + url)}`,
  };

  const openShareWindow = (shareUrl) => {
    window.open(shareUrl, '_blank', 'width=600,height=400');
  };

  return (
    <div className="relative">
      {/* Share Button */}
      <Tooltip title="Share with Whatsapp, or Telegram">
       <IconButton onClick={() => {
          if (canUseNativeShare) {
            handleNativeShare();
          } else {
            setIsOpen(!isOpen);
          }
        }}
        size='small'
        >
          {loading ? <CircularProgress size={20} /> : <ShareRoundedIcon size={20} color="info" />}
        </IconButton> 
      </Tooltip>

      {/* Desktop Share Modal */}
      {isOpen && !canUseNativeShare && (
        <>
          {/* Backdrop */}
          <div 
            className="fixed inset-0 bg-black bg-opacity-50 z-40"
            onClick={() => setIsOpen(false)}
          />
          
          {/* Modal */}
          <div className="absolute top-full mt-2 right-0 bg-white rounded-lg shadow-xl p-4 z-50 w-80">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold text-gray-800">Share</h3>
              <button
                onClick={() => setIsOpen(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                <CloseRoundedIcon size={20} />
              </button>
            </div>

            <div className="space-y-2">

              {/* WhatsApp */}
              <button
                onClick={() => openShareWindow(shareLinks.whatsapp)}
                className="w-full flex items-center gap-3 p-3 rounded-lg hover:bg-gray-100 transition-colors text-left"
              >
                <div className="w-10 h-10 bg-green-500 rounded-full flex items-center justify-center">
                  <Whatsapp size={20} className="text-white" />
                </div>
                <span className="text-gray-700 font-medium">WhatsApp</span>
              </button>

              {/* Telegram */}
              <button
                onClick={() => openShareWindow(shareLinks.telegram)}
                className="w-full flex items-center gap-3 p-3 rounded-lg hover:bg-gray-100 transition-colors text-left"
              >
                <div className="w-10 h-10 bg-blue-400 rounded-full flex items-center justify-center">
                  <Telegram size={20} className="text-white" />
                </div>
                <span className="text-gray-700 font-medium">Telegram</span>
              </button>
             
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ShareButton;